<template>
  <div class="c-app flex-row align-items-center mt-4">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm>
                <h1 class="mb-4">アカウント情報</h1>
                <CInput
                  class="account"
                  v-model="user.name"
                  placeholder="Username"
                  autocomplete="username">
                </CInput>
                <CInput
                  class="email"
                  v-model="user.email"
                  placeholder="Email"
                  autocomplete="email">
                </CInput>
                <CInput
                  class="tel"
                  v-model="user.tel"
                  placeholder="Tel">
                </CInput>
                <CInput
                  v-if="!isAdmin()"
                  class="mt-5 password"
                  v-model="user.password_befor"
                  placeholder="現在のPassword"
                  type="password"
                  autocomplete="new-password">
                </CInput>
                <CInput
                  class="password"
                  v-model="user.password_after"
                  placeholder="新しいPassword"
                  type="password"
                  autocomplete="new-password">
                </CInput>
                <CSelect
                  class="mt-5"
                  v-if="isAdmin()"
                  :disabled = "user.status=='8'"
                  :value.sync="user.status"
                  :options="options"
                  placeholder="Please select"
                />
                <div class="form-group" v-if="isAdmin()">
                  <input v-model="user.closed_at" type="date" class="form-control">
                </div>
                <CRow class="mt-3">
                  <CCol col="12" class="text-center">
                    <CButton class="mt-2 px-4 mr-2" color="primary" @click="goBack()">戻る</CButton>
                    <CButton class="mt-2 px-4 ml-2" color="success" @click="putData()">送信</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>
<script>
export default {
  name: 'User',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.usersOpened = from.fullPath.includes('users')
    })
  },
  data () {
    return {
      user:{
        id:0,
        name:"",
        email:"",
        tel:"",
        status:"0"
      },
      rowStatus:"",
      options: [
        { value: "0", label: '利用者認証待ち' },
        { value: "1", label: 'スタッフ認証待ち' },
        { value: "2", label:  '利用可能'},
        { value: "9", label:  '利用停止'},
      ],
    }
  },
  mounted: function () {
    let api = new ApiService();
    api.getUser(this.$route.params.id)
      .then((response) => {
        this.user = response[0];
        let today = moment();
        if(this.user.closed_at){
          if(!moment(this.user.closed_at).isAfter(today, 'day')){
            this.rowStatus = this.user.status;
            this.user.status = '8';
            this.options.push({ value: "8", label:  '有効期限外'});
          }
          this.user.closed_at = moment(this.user.closed_at).format('YYYY-MM-DD');
        }
      })
      .catch((error) => {
        this.$swal('エラー', "ユーザー情報が正しく取得できません", 'error');
      });
  },
  methods: {
    putData () {
      const REG_EMAIL = /^[A-Za-z0-9]{1}[A-Za-z0-9_.+-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
      if(!REG_EMAIL.test(this.user.email)){
        this.$swal('エラー', "メールアドレスを正しく入力してください", 'error');
        return false;
      }
      let api = new ApiService();
      if(this.user.closed_at){
        this.user.closed_at = moment(this.user.closed_at).format('YYYY-MM-DD 00:00:00');
      }
      if(this.user.status == "8"){
        this.user.status = this.rowStatus;
      }
      api.putUser(this.user)
        .then((response) => {
          this.$swal('完了', "ユーザー情報を変更しました", 'success')
            .then(() => {
              if(this.isAdmin()){
                this.$router.push({path: '/app/color/users'});
              }else{
                this.$router.push({path: '/app/color/diagnosis'});
              }
            });
        })
        .catch((error) => {
          if(error.status === 409){
            this.$swal('エラー', "既に登録されているメールアドレスです。", 'error');
          }
          if(error.status === 500){
            this.$swal('エラー', "登録が失敗しました、解決しない場合はサポートチームへお問い合わせください。", 'error');
          }
        });
    },
    isAdmin(){
      return (localStorage.isAdmin == "1");
    },
    goBack() {
      if(this.isAdmin()){
        this.$router.push({path: '/app/color/users'});
      }else{
        this.$router.push({path: '/app/color/diagnosis'});
      }      
    }
  }
}
</script>
